/**
 * Converts string in rgb/rgba format into rgba values object
 * @param {String} rgbaString - The given rgba color
 * @returns {Object}
 */
const getRGBAValues = (rgbaString) => {
    const rgbaValues = rgbaString.substring(rgbaString.indexOf('(') +1, rgbaString.length -1).split(',');
    const opacity = Number.isNaN(parseInt(rgbaValues[3], 10)) ? 1 : Number(rgbaValues[3]);

    return {
        r: Number(rgbaValues[0]),
        g: Number(rgbaValues[1]),
        b: Number(rgbaValues[2]),
        a: opacity
    };
};

module.exports = getRGBAValues;
